// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalV1MedicalEligibilityRequestSearchDefaultResponse {
    static getAttributeTypeMap() {
        return MedicalV1MedicalEligibilityRequestSearchDefaultResponse.attributeTypeMap;
    }
}
MedicalV1MedicalEligibilityRequestSearchDefaultResponse.discriminator = undefined;
MedicalV1MedicalEligibilityRequestSearchDefaultResponse.additionalProperties = false;
MedicalV1MedicalEligibilityRequestSearchDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "MedicalV1MedicalEligibilityRequestSearchDefaultResponseData"
    },
];
//# sourceMappingURL=medicalV1MedicalEligibilityRequestSearchDefaultResponse.js.map